import React from 'react';
import classes from './layout.module.css';
import Header from '../header/header';
import Subscribe from '../subscribe/subscribe';

const Layout = (props: any) => {
  return (
    <div className={classes.layout}>
      <Header />
      {props.children}
    </div>
  );
};

export default Layout;
